import React from 'react';
import { useNavigate } from 'react-router-dom';

const MilkyWayCasino = ({ gameDetails }) => {
    const navigate = useNavigate();

    return (
        <div className='container mx-auto my-10 px-4'>
            <div>
                <div className='flex flex-col md:flex-row gap-5'>
                    <div className='flex items-center flex-col md:flex-row justify-center gap-5'>
                        <div className='w-[300px] md:w-[30%] flex items-center justify-center'>
                            <img src={gameDetails?.game_image} alt={gameDetails?.game_name} className='w-full object-container' />
                        </div>
                        <div className='text-white flex flex-col gap-3 w-full md:w-[65%]'>
                            <h1 className='font-bold text-3xl uppercase'>{gameDetails?.game_name}</h1>
                            <p className='text-[#CACACA]'>{gameDetails?.game_description?.replace(/\\r\\n/g, ' ')}</p>
                            <div className='mt-3'>
                                <button
                                    className="bg-[#FFDD15] text-black font-bold py-2 px-4 rounded text-sm sm:text-base"
                                    onClick={() => navigate('/deposit')}
                                >
                                    DEPOSIT NOW
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {gameDetails?.game_related_platform?.map((relatedGame, index) => (
                <div
                    key={relatedGame.id}
                    className={`bg-[#290A47] border-b-[3px] ${index % 2 === 0
                        ? 'border-l-[3px] lg:flex-row-reverse'
                        : 'border-r-[3px] lg:flex-row'
                        } border-[#EC29FC] p-6 rounded-lg flex flex-col lg:flex-row justify-between items-center text-white mt-20 gap-5`}
                >
                    <div className="w-full lg:ml-6">
                        <img
                            src={relatedGame.game_image}
                            alt={relatedGame.game_name}
                            className="rounded-lg w-full sm:w-[250px]"
                        />
                    </div>
                    <div className="flex flex-col gap-2">
                        <h2 className="text-xl sm:text-2xl font-bold mb-4">{relatedGame.game_name.toUpperCase()}</h2>
                        <p className="text-[#CACACA] text-sm sm:text-base">
                            {relatedGame.game_description.replace(/\\r\\n/g, ' ')}
                        </p>
                        <div className="mt-4">
                            <button className="bg-[#FFDD15] text-black font-bold py-2 px-4 rounded text-sm sm:text-base"
                             onClick={() => navigate('/deposit')}>
                                DEPOSIT NOW
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default MilkyWayCasino;
